// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdminHead_wrapper__qJGaE","fix":"AdminHead_fix__980kB","privilege":"AdminHead_privilege__Mj0xu","filters":"AdminHead_filters__euUT6"};